import React, { useState } from 'react';
import { StandardReference } from '../../models/Standards/standard-reference';
import { StandardLot } from '../../models/Standards/standard-lot';
import { CrudFunctions } from '../../utilities/crud-functions';
import DmaFooter from '../DmaFooter';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType, StandardUpdateState } from '../../models/enums';
import GlobalDialog from '../Modal/GlobalDialog';

import DataGrid, {
    Column,
    FilterRow,
    Pager,
    Paging,
    Selection,
    HeaderFilter,
    Scrolling,
    SearchPanel,
    Export,
    Toolbar,
    Item as ToolbarItem
} from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';

export default function UspRefStandardsForm() {
    const [uspRefStandards, setUspRefStandards] =
        useState<StandardReference[]>();

    const [uspRefStandardsNewLots, setUspRefStandardsNewLots] =
        useState<StandardLot[]>();

    const [isLoading, setIsLoading] =
        useState<boolean>(false);

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();
    
    return (
        <div className="pw-content">
            <div className="lq-title-bar">
                <div className="lq-main-title">USP Reference Standards Maintenance</div>
                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <div>
                        <Button className="title-bar-button"
                            id="goBackButton" text="" icon="arrowleft" type="normal"
                            hint="go back"
                            onClick={goBack} />
                    </div>
                </div>
            </div>

            <div className="pw-comp-row">
                <div>
                    <Button id="getUspDailyCatalogButton" className="pw-row-button-08" height='1.6rem'
                        type="success" text="Get USP Catalog" onClick={getUspDailyCatalog} />
                </div>
                <div className="pw-margin-left-05">
                    <Button id="updateDatabaseButton" className="pw-row-button-08" height='1.6rem'
                        disabled={!uspRefStandards}
                        type="success" text="Update Database" onClick={onUpdateReferencesToDatabase} />
                </div>
            </div>

            <LoadPanel visible={isLoading} />
            <DataGrid id="uspCatalogDataGrid"
                width='100%' height="26rem"
                dataSource={uspRefStandards ?
                    uspRefStandards : []}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnResizingMode='nextColumn'
                onExporting={onExporting}
                showBorders={true}>
                
                <Selection mode={'single'} />
                <Scrolling showScrollbar='always' rowRenderingMode='virtual' />
                <Paging enabled={true} defaultPageSize={50} />
                <Pager visible={true} showInfo={true}
                    displayMode="full"
                    showNavigationButtons={true}
                    allowedPageSizes={[50, 100, "all"]} />
                <HeaderFilter visible={true} />
                <FilterRow visible={true} />
                <SearchPanel visible={true} />
                <Export enabled={true} allowExportSelectedData={true} />

                <Column dataField='deviationFromDmaDatabase' caption="" width='4rem'
                    cellRender={deviationFromDmaDatabaseDatagridCellRender} />

                <Column dataField='catalogNumber' caption="Catalog#" dataType="string" width='7rem' />
                <Column dataField='productName' dataType="string" />
                <Column dataField='currentLot' caption="Current Lot#" dataType="string" width='7rem'
                    cellRender={currentLotDatagridCellRender}/>
                <Column dataField='casNumber' caption='CAS #' dataType="string" width='6rem' />
                <Column dataField='status' dataType="string" width='5rem' />

                {/*
                    <Column dataField='previousLot' width='6rem' />
                    <Column dataField='previousLotDate' width='8rem' dataType="date" />
                */}

                <Column dataField='netWeight' width='6rem' dataType="number" />
                <Column dataField='netWeightUomString' caption="UOM" dataType="string" width='6rem' />
                <Column cellRender={uspStandardCertificateRenderer} caption="COA" width="6rem" />
                <Column cellRender={uspStandardMsdsRenderer} caption="MSDS" width="6rem" />
                
                <Toolbar>
                    <ToolbarItem location='before'>
                        <div className="pw-datagrid-toolbar-template">
                            <div className="pw-datagrid-toobar-title">USP Reference Standards</div>
                        </div>
                    </ToolbarItem>
                    <ToolbarItem name="exportButton" />
                    <ToolbarItem name="searchPanel" />
                </Toolbar>
            </DataGrid>

            <div>
                <DataGrid id="uspCatalogNewLotsDataGrid"
                    width="100%" height="20rem"
                    dataSource={uspRefStandardsNewLots ?
                        uspRefStandardsNewLots : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='nextColumn'
                    showBorders={true}>

                    <Selection mode={'single'} />
                    <Scrolling showScrollbar='always' />
                    <Paging enabled={false} />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <SearchPanel visible={true} />

                    <Column dataField='updateState' caption="" width='4rem' alignment="center"
                        cellRender={uspChangesUpdateStateDatagridCellRender} />
                    <Column dataField='catalogNumber' dataType="string" width='8rem' />
                    <Column dataField='productName' dataType="string" />
                    <Column dataField='currentLot' dataType="string" width='6rem' />
                    <Column dataField='newLot' dataType="string" width='6rem' />

                    {/*
                    <Column dataField='previousLotDate' width='8rem' dataType="date" />
                    <Column />
                    */}

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">USP Standard Changes</div>
                            </div>
                        </ToolbarItem>
                        <ToolbarItem name="searchPanel" />
                    </Toolbar>
                </DataGrid>
            </div>

            <DmaFooter />

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    async function onUpdateReferencesToDatabase() {
        if (uspRefStandards) {
            await updateStandardReferences(uspRefStandards)
                .then((data) => {
                    //add toast
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Standard References");
                });
        }
    }

    async function getUspDailyCatalog() {
        setIsLoading(true);
        await CrudFunctions.getData("externaldata/uspdailycatalog")
            .then(data => {
                //console.log("USP:");
                //console.log(data);

                setUspRefStandards(data);
                                
                const newLots = data.filter((d: any) => d.deviationFromDmaDatabase === true);

                console.log("newLots:");
                console.log(newLots);

                setUspRefStandardsNewLots(newLots);
                
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving USP Daily Catalog");
            })
            .finally(() => setIsLoading(false));
    }

    async function updateStandardReferences(standardReferences: StandardReference[]) {
        return await CrudFunctions.postData("standards/standardreferences", standardReferences);            
    }

    //navigation

    function goBack() {
        history.back();
    }

    //render

    function uspStandardCertificateRenderer(e: any) {
        console.log("uspStandardCertificateRenderer");
        console.log(e);

        if (e.data && e.data.catalogNumber && e.data.currentLot) {
            const urlRef = `${e.data.catalogNumber}-${e.data.currentLot}`;

            let url = `https://static.usp.org/pdf/EN/referenceStandards/certificates/${urlRef}.pdf`

            return <a href={url} rel="noopener noreferrer" target="_blank">Certificate</a>;
        }
        else
            return <div>NA</div>;
    }

    function uspStandardMsdsRenderer(e: any) {
        if (e.data && e.data.catalogNumber) {
            let url = `https://static.usp.org/pdf/EN/referenceStandards/msds/${e.data.catalogNumber}.pdf`

            return <a href={url} rel="noopener noreferrer" target="_blank">MSDS</a>;
        }
        else
            return <div>NA</div>;
    }

    function deviationFromDmaDatabaseDatagridCellRender(e: any) {
        if (e.data && e.data.deviationFromDmaDatabase) {
            return (
                <div>
                    <div className="item-main"><i className="dx-icon-warning pw-red"></i></div>
                </div>
            );
        }
        else
            return (<div></div>);
    }

    function currentLotDatagridCellRender(e: any) {
        if (e.data && e.data.deviationFromDmaDatabase) {
            return (
                <div>
                    <div className="pw-red">{e.data.currentLot}</div>
                </div>
            );
        }
        else
            return (
                <div>
                    <div>{e.data.currentLot}</div>
                </div>
            );
    }

    function uspChangesUpdateStateDatagridCellRender(e: any) {
        if (e.data && e.data.updateState) {
            switch (e.data.updateState) {
                case StandardUpdateState.NewStandard:
                    return <div><div className="item-main"><i className="dx-icon-add pw-green"></i></div></div>;
                case StandardUpdateState.CurrentLotChange:
                    return <div><div className="item-main"><i className="dx-icon-clock pw-orange"></i></div></div>;
                case StandardUpdateState.Discontinued:
                    return <div><div className="item-main"><i className="dx-icon-warning pw-red"></i></div></div>;
                case StandardUpdateState.Planned:
                    return <div><div className="item-main"><i className="dx-icon-eyeopen pw-blue"></i></div></div>;
            }
        }
        else
            return (<div></div>);
    }

    function onExporting(e: any) {
        const name = "USP Reference Standards";
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('USP');

        exportDataGrid({
            component: e.component,
            worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${name}.xlsx`);
            });
        });

        e.cancel = true;
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}
